import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';

/** Which Stripe dashboard entity to open. */
type StripeEntity = 'customers' | 'subscriptions';

interface Props {
    /** Stripe id (cus_… for customers, sub_… for subscriptions). Renders nothing when null/empty. */
    id: string | null;
    entity: StripeEntity;
}

const TOOLTIP: Record<StripeEntity, string> = {
    customers: 'Open Stripe customer',
    subscriptions: 'Open Stripe subscription',
};

/**
 * Small external-link icon that opens a Stripe dashboard record in a new tab.
 * Renders nothing when no id is available.
 */
const StripeLink = ({ id, entity }: Props) => {
    if (!id) {
        return null;
    }

    return (
        <Tooltip title={TOOLTIP[entity]}>
            <IconButton
                component="a"
                href={`https://dashboard.stripe.com/${entity}/${id}`}
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                onClick={(e) => e.stopPropagation()}
                sx={{ ml: 0.5, p: 0.25, color: 'text.secondary' }}
            >
                <OpenInNewIcon sx={{ fontSize: '0.95rem' }} />
            </IconButton>
        </Tooltip>
    );
};

export default StripeLink;
